/* eslint-disable max-lines */
/* eslint-disable react/prop-types */
/* eslint-disable no-magic-numbers */
/**
 * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package scandipwa/base-theme
 * @link https://github.com/scandipwa/base-theme
 */
import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import { connect } from 'react-redux';

import { CART_OVERLAY } from 'Component/Header/Header.config';
import { SCROLL_DISTANCE, SCROLL_TIMEOUT } from 'Util/Browser';
import history from 'Util/History';
/** @namespace Bodypwa/Component/StikyHeader/Container/mapStateToProps */
export const mapStateToProps = (state) => ({
    activeOverlay: state.OverlayReducer.activeOverlay,
    updateScroll: state.UiReducer.updateScroll,
    isResetHeader: state.UiReducer.isResetHeader,
    filtersHeight: state.UiReducer.filtersHeight,
    headerElement: state.UiReducer.headerElement,
    headerTopRef: state.UiReducer.headerTopRef,
    filterElement: state.UiReducer.filterElement,
    filterTopRef: state.UiReducer.filterTopRef,
    isSideMenuOpen: state.SideMenuReducer?.isSideMenuOpen
});

/** @namespace Bodypwa/Component/StikyHeader/Container/mapDispatchToProps */
export const mapDispatchToProps = () => ({
});

/** @namespace Bodypwa/Component/StikyHeader/Container */
export class StikyHeaderContainer extends PureComponent {
    static propTypes = {
        activeOverlay: PropTypes.string,
        // eslint-disable-next-line react/boolean-prop-naming
        updateScroll: PropTypes.bool,
        headerElement: PropTypes.shape({}).isRequired
    };

    lastScrollPos = 0;

    lastScrollTop = 0;

    isStiky = false;

    isStikyFilter = false;

    filterVisible = false;

    isScrollingDown = false;

    state = {
        location: history.location
    };

    static defaultProps = {
        activeOverlay: null,
        updateScroll: false
    };

    componentDidMount() {
        history.listen((history) => {
            this.onRouteChanged(history);
        });
        window.addEventListener('scroll', this.handleScroll.bind(this));
    }

    componentDidUpdate() {
        const {
            headerElement, activeOverlay, updateScroll, filterElement: filterRef, filtersHeight
        } = this.props;

        if (this.isStiky) {
            headerElement.classList.add('isSticky');
        }

        if ((activeOverlay && activeOverlay !== CART_OVERLAY) || updateScroll) {
            this.resetHederPosition();
            this.resetFiltersPostion();
        }

        const filtersHeightPixels = `${filtersHeight}px`;
        const topPositionFilter = document.documentElement.style.getPropertyValue('--top-postion-filter');
        if (filterRef && topPositionFilter !== filtersHeightPixels && !this.filterVisible && this.isStikyFilter) {
            document.documentElement.style.setProperty('--top-postion-filter', filtersHeightPixels);
            filterRef.style.transform = `translateY(-${filtersHeightPixels})`;
        }

        if (!filterRef) {
            this.resetFiltersPostion();
        }
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll.bind(this));
    }

    onRouteChanged(history) {
        const { location: { pathname: prevPathname } = {} } = this.state;
        const { pathname } = history;
        if (prevPathname !== pathname) {
            this.resetHederPosition();
            this.resetFiltersPostion();
            this.setState({ location: history });
        }
    }

    resetHederPosition() {
        const { headerElement } = this.props;
        if (!headerElement) {
            return;
        }
        this.isStiky = false;
        headerElement.style.transform = 'translateY(0)';
        headerElement.classList.remove('isSticky');
        document.documentElement.classList.remove('stikyHeader');
        headerElement.classList.remove('isHidden');
        this.lastScrollTop = window.scrollY;
        this.headerVisible = false;
    }

    resetFiltersPostion() {
        const { filterElement: filterRef, filterTopRef: topPannelRef } = this.props;
        if (!filterRef) {
            document.documentElement.classList.remove('stikyFilter');
            document.documentElement.style.setProperty('--top-postion-filter', 0);
            this.filterVisible = false;
            this.isStikyFilter = false;
            return;
        }
        const { height: filtersHeight } = filterRef.getBoundingClientRect();
        filterRef.style.transform = 'translateY(0)';
        filterRef.classList.remove('isStickyVisible');
        document.documentElement.classList.remove('stikyFilter');
        topPannelRef.style.minHeight = `${filtersHeight}px`;
        this.filterVisible = false;
        this.isStikyFilter = false;
    }

    handleScroll() {
        const {
            headerElement, headerTopRef, filterTopRef: topPannelRef, filterElement: filterRef, isSideMenuOpen
        } = this.props;

        if (!headerElement) {
            return;
        }
        const { height: headerHeight } = headerElement.getBoundingClientRect();
        const { activeOverlay, updateScroll } = this.props;
        document.documentElement.style.setProperty('--top-postion-header', `${ headerHeight}px`);

        if ((activeOverlay && activeOverlay !== CART_OVERLAY) || updateScroll
         || (!window.scrollY && !isSideMenuOpen)) {
            this.resetHederPosition();
            this.resetFiltersPostion();
            return;
        }
        clearTimeout(this.scrollEndTimeout);
        this.scrollEndTimeout = setTimeout(this.handleScrollEnd, SCROLL_TIMEOUT);
        const currentScrollPos = window.scrollY;

        if (currentScrollPos > this.lastScrollPos) {
            this.isScrollingDown = true;
        } else if (currentScrollPos < this.lastScrollPos) {
            this.isScrollingDown = false;
        }

        const scrollDistance = this.lastScrollTop - currentScrollPos;
        this.lastScrollPos = currentScrollPos;
        if (scrollDistance === 0) {
            return;
        }
        if (topPannelRef && filterRef) {
            const { height: filtersHeight, bottom } = filterRef.getBoundingClientRect();
            topPannelRef.style.minHeight = `${filtersHeight}px`;
            const topPannelRect = topPannelRef.getBoundingClientRect();
            document.documentElement.style.setProperty('--top-postion-filter', `${ filtersHeight }px`);
            if (topPannelRect.bottom < 0 && this.isScrollingDown && this.filterVisible) {
                filterRef.classList.add('isStickyVisible');
                document.documentElement.classList.add('stikyFilter');
                this.isStikyFilter = true;
                this.filterVisible = false;
                filterRef.style.transform = `translateY(-${filtersHeight}px)`;
            } else if (!this.isScrollingDown) {
                if ((topPannelRect.bottom > filtersHeight + headerHeight && this.filterVisible)
                    || (topPannelRect.bottom > -(filtersHeight + headerHeight) && !this.filterVisible)) {
                    filterRef.classList.remove('isStickyVisible');
                    this.filterVisible = false;
                    this.isStikyFilter = false;
                    document.documentElement.classList.remove('stikyFilter');
                    filterRef.style.transform = 'translateY(0px)';
                } else if (scrollDistance > SCROLL_DISTANCE) {
                    filterRef.classList.add('isStickyVisible');
                    document.documentElement.classList.add('stikyFilter');
                    this.filterVisible = true;
                    this.isStikyFilter = true;
                    filterRef.style.transform = `translateY(${headerHeight}px)`;
                }
            } else if (bottom <= 0 && !this.isStikyFilter) {
                this.isStikyFilter = true;
                filterRef.style.transform = `translateY(-${filtersHeight}px)`;
                setTimeout(() => {
                    filterRef.classList.add('isStickyVisible');
                    document.documentElement.classList.add('stikyFilter');
                }, 10);
                this.filterVisible = false;
            }
        } else {
            document.documentElement.style.setProperty('--top-postion-filter', `${ 0 }px`);
        }

        if (headerTopRef && headerElement) {
            const headerTopRect = headerTopRef.getBoundingClientRect();
            const { height: filtersHeight = 0 } = filterRef?.getBoundingClientRect() || {};
            if (headerTopRect.bottom < -headerHeight && this.isScrollingDown && this.headerVisible) {
                this.isStiky = true;
                headerElement.style.transform = `translateY(-${headerHeight + filtersHeight}px)`;
                headerElement.classList.add('isSticky');
                document.documentElement.classList.add('stikyHeader');
                headerElement.classList.add('isHidden');
                this.headerVisible = false;
            } else if (!this.isScrollingDown) {
                if ((headerTopRect.bottom > 0 && this.headerVisible)
                    || (headerTopRect.bottom > -headerHeight && !this.headerVisible)) {
                    this.isStiky = false;
                    headerElement.classList.remove('isSticky');
                    document.documentElement.classList.remove('stikyHeader');
                    headerElement.classList.remove('isHidden');
                    headerElement.style.transform = 'translateY(0px)';
                    this.headerVisible = false;
                } else if (scrollDistance > SCROLL_DISTANCE) {
                    this.isStiky = true;
                    headerElement.classList.add('isSticky');
                    document.documentElement.classList.add('stikyHeader');
                    headerElement.classList.remove('isHidden');
                    this.headerVisible = true;
                    headerElement.style.transform = 'translateY(0px)';
                }
            } else if (headerTopRect.bottom <= -headerHeight && !this.isStiky) {
                this.isStiky = true;
                headerElement.style.transform = `translateY(-${headerHeight + filtersHeight}px)`;
                setTimeout(() => {
                    headerElement.classList.add('isSticky');
                    document.documentElement.classList.add('stikyHeader');
                    headerElement.classList.add('isHidden');
                }, 10);
                this.headerVisible = false;
            }
        }
    }

    handleScrollEnd = () => {
        const scrollTop = window.scrollY || document.documentElement.scrollTop;
        this.lastScrollTop = scrollTop;
    };

    render() {
        return null;
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(StikyHeaderContainer);
